import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-gst-popup',
  templateUrl: './gst-popup.component.html',
  styleUrls: ['./gst-popup.component.scss']
})
export class GstPopupComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }
  closeModal(){
    this.dialog.closeAll();
  }
}
